import { createFileRoute } from '@tanstack/react-router';
import { InvoicesPage } from '../features/invoices/InvoicesPage';
import { validateInvoicesSearch } from '../features/invoices/search';

export const Route = createFileRoute('/invoices')({
  validateSearch: validateInvoicesSearch,
  component: InvoicesPage,
});
